import React from 'react';
import { Box } from '@mui/material';

// Published visibly per the client's build notes — not tucked away in an
// FAQ or footer, and phrased so nobody has to ask.
export default function HardshipNote() {
  return (
    <Box
      sx={{
        maxWidth: 760,
        mx: 'auto',
        mt: 5,
        p: { xs: 2.5, md: 3 },
        textAlign: 'center',
        border: '1px dashed rgba(36,34,88,0.3)',
        background: 'rgba(36,34,88,0.04)',
        fontFamily: 'var(--font-body)',
        fontSize: 14.5,
        color: 'var(--navy-500)',
        lineHeight: 1.6,
      }}
    >
      No family will ever be turned away for financial reasons — reach out confidentially at{' '}
      <Box
        component="a"
        href="mailto:office@kbtla.org"
        sx={{ color: 'var(--teal-500)', fontWeight: 700, textDecoration: 'none' }}
      >
        office@kbtla.org
      </Box>
      .
    </Box>
  );
}
